<template>
  <v-card outlined style="margin-bottom: 24px;">
    <UpdateLeadExtra :state="updateLeadDialog" :profile="profile" @refresh="refresh" @closeDialog="closeDialog" />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class=" text-uppercase align-self-center">Thông tin thêm</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="updateLead"
        style="height: 18px;"
        v-if="authorized"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhập
      </v-btn>
    </div>
    <v-row class="px-6" no-gutters>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Mã hồ sơ</p>
        <p class=" mt-0">
          <template v-if="profile.activeCodes && profile.activeCodes.length > 0">
            <template v-for="(codeObj, index) in profile.activeCodes">
              <v-btn
                v-if="codeObj"
                :key="index"
                color="blue darken-4"
                class="document-btn px-0 no-hover"
                text
                @click="navigateToDocument(codeObj.code)"
                plain
                height="17"
              >
                {{ codeObj.code }}
              </v-btn>

              <span v-if="index < profile.activeCodes.length - 1" :key="'comma-' + index">, </span>
            </template>
          </template>
          <span v-else>Chưa có</span>
        </p>
      </v-col>
    </v-row>

    <template v-if="hasStudentData">
      <div v-for="(student, index) in profile.data.student" :key="index">
        <v-row class="px-6 pb-6" no-gutters>
          <v-col cols="3">
            <p class="grey--text mb-0 mt-0">Tên học sinh {{ index + 1 }}</p>
            <p class="mb-0 mt-0">{{ student.name || '-' }}</p>
          </v-col>
          <v-col cols="3">
            <p class="grey--text mb-0 mt-0">Ngày sinh</p>
            <p class="mb-0 mt-0">{{ student.dob || '-' }}</p>
          </v-col>
          <v-col cols="3">
            <p class="grey--text mb-0 mt-0">Trường</p>
            <p class="mb-0 mt-0">{{ student.school || '-' }}</p>
          </v-col>
          <v-col cols="3">
            <p class="grey--text mb-0 mt-0">Lớp đang học</p>
            <p class="mb-0 mt-0">{{ student.class || '-' }}</p>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-else>
      <v-row class="px-6 pb-6" no-gutters>
        <v-col cols="3">
          <p class="grey--text mb-0 mt-0">Tên học sinh</p>
          <p class="mb-0 mt-0">-</p>
        </v-col>
        <v-col cols="3">
          <p class="grey--text mb-0 mt-0">Ngày sinh</p>
          <p class="mb-0 mt-0">-</p>
        </v-col>
        <v-col cols="3">
          <p class="grey--text mb-0 mt-0">Trường</p>
          <p class="mb-0 mt-0">-</p>
        </v-col>
        <v-col cols="3">
          <p class="grey--text mb-0 mt-0">Lớp đang học</p>
          <p class="mb-0 mt-0">-</p>
        </v-col>
      </v-row>
    </template>
  </v-card>
</template>
<script>
import UpdateLeadExtra from '@/components/basic/form/UpdateLeadExtra.vue'

export default {
  props: {
    profile: Object,
    authorized: Boolean
  },
  components: {UpdateLeadExtra},
  data() {
    return {
      updateLeadDialog: false,
      studentDialog: false,
      noteDialog: false
    }
  },
  computed: {
    hasStudentData() {
      return this.profile.data && this.profile.data.student && this.profile.data.student.length > 0
    }
  },
  methods: {
    updateLead() {
      this.updateLeadDialog = true
    },
    closeDialog() {
      this.updateLeadDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },

    navigateToDocument(code) {
      const url = `/admin/document?code=${code}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style>
.no-hover.v-btn--plain .v-btn__content {
  opacity: 1 !important;
}
</style>
